import { render, staticRenderFns } from "./SignUpStaff.vue?vue&type=template&id=939c0ec4&scoped=true"
import script from "./SignUpStaff.vue?vue&type=script&lang=js"
export * from "./SignUpStaff.vue?vue&type=script&lang=js"
import style0 from "./SignUpStaff.vue?vue&type=style&index=0&id=939c0ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939c0ec4",
  null
  
)

export default component.exports